module.exports = __webpack_public_path__ + "img/app-preview.aba915ed.svg";